import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.AirwallexContext', {
    wagesOrSalary: 'Wages or salary',
});
